/**
 * Central branding configuration.
 *
 * The product name is temporary. Every user-facing reference to the product
 * (web title, PWA manifest, emails, export README, About screen) reads from
 * this object. Nothing here is used as a database identifier, protocol value,
 * cookie name, storage key or permission concept — renaming the product is a
 * matter of editing this file and regenerating icons (`npm run icons`).
 */
export interface BrandConfig {
  /** Full product name, e.g. in the About screen and email footers. */
  productName: string;
  /** Short name for the home-screen icon label and compact headers. */
  shortName: string;
  tagline: string;
  description: string;
  /** Lowercase, filename-safe prefix used only for user downloads (exports). */
  fileSlug: string;
  /** Display name used in the "From" header of outgoing email. */
  emailFromName: string;
  supportEmail: string;
  /** Browser UI chrome color for the PWA manifest (the in-app theme is separate). */
  manifestThemeColor: string;
  manifestBackgroundColor: string;
  /** Icon files served from the web app's public folder. Regenerate with `npm run icons`. */
  icons: {
    svg: string;
    favicon: string;
    png192: string;
    png512: string;
    maskable512: string;
    appleTouch: string;
  };
  /**
   * Simple geometric description of the app icon, used by
   * scripts/generate-icons.mjs to render SVG + PNG assets.
   */
  iconArt: {
    background: string;
    foreground: string;
    accent: string;
  };
  legal: {
    organizationName: string;
    privacyUrl: string;
    termsUrl: string;
  };
}

export const brand: BrandConfig = {
  productName: 'Family: the Gatherings',
  shortName: 'Gatherings',
  tagline: 'Your family, organized together.',
  description: 'A calm shared home base for your family: calendar, lists, chores, meals, photos and important records — available even when you are offline.',
  fileSlug: 'gatherings',
  emailFromName: 'Family: the Gatherings',
  supportEmail: 'support@example.com',
  manifestThemeColor: '#2d6a5a',
  manifestBackgroundColor: '#f6f4ef',
  icons: {
    svg: '/brand/icon.svg',
    favicon: '/brand/favicon.svg',
    png192: '/brand/icon-192.png',
    png512: '/brand/icon-512.png',
    maskable512: '/brand/icon-maskable-512.png',
    appleTouch: '/brand/apple-touch-icon.png',
  },
  iconArt: {
    background: '#2d6a5a',
    foreground: '#f6f4ef',
    accent: '#f2b84b',
  },
  legal: {
    organizationName: 'Your Organization',
    privacyUrl: '',
    termsUrl: '',
  },
};
